import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: 'basic-dialog',
  templateUrl: './basic-dialog.component.html',
  styleUrls: ['./basic-dialog.component.css']
})
export class BasicDialogComponent implements AfterViewInit {
  @Input()
  title: string = "";
  @Input()
  content: string = "";
  constructor(public activeModal: NgbActiveModal) {
  }
  ngAfterViewInit(): void {
  }
}
